import { Routes } from '@angular/router';
import { PathEnum, RoutesEnum } from './shared/enums/path-enum';
import { NoAuthGuard } from './guard/noAuth.guard';
import { AuthGuard } from './guard/auth.guard';
import { ModalGuard } from './guard/modal.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: PathEnum.LOGIN,
    pathMatch: 'full'
  },
  {
    canActivate: [AuthGuard],
    path: 'pages',
    loadChildren: () => import('./pages/pages.module').then(m => m.PagesPageModule)
  },
  {
    canActivate: [NoAuthGuard],
    canDeactivate: [ModalGuard],
    path: RoutesEnum.LOGIN,
    title: 'Accedi',
    loadChildren: () => import('./pages/login/login.module').then(m => m.LoginPageModule)
  },
  {
    canDeactivate: [ModalGuard],
    path: RoutesEnum.RECOVER_PASSWORD,
    title: 'Recupera password',
    loadChildren: () => import('./pages/verify-account/verify-account.module').then(m => m.VerifyAccountPageModule)
  },
  {
    canDeactivate: [ModalGuard],
    path: 'verify-account',
    title: 'Verifica account',
    loadChildren: () => import('./pages/verify-account/verify-account.module').then(m => m.VerifyAccountPageModule)
  },
  {
    canDeactivate: [ModalGuard],
    path: 'enable-account',
    title: 'Abilita account',
    loadChildren: () => import('./pages/enable-account/enable-account.module').then(m => m.EnableAccountPageModule)
  },
  {
    path: 'esito-positivo',
    title: 'Esito positivo',
    loadChildren: () => import('./pages/redirect-ok/redirect-ok.module').then(m => m.RedirectOkPageModule)
  },
  {
    path: 'esito-negativo',
    title: 'Esito negativo',
    loadChildren: () => import('./pages/redirect-ko/redirect-ko.module').then(m => m.RedirectKoPageModule)
  },
  {
    path: RoutesEnum.GUIDA_RENDICONTAZIONE,
    title: 'Guida pagamenti',
    loadChildren: () => import('./pages/guida-pagamenti-rendicontazione/guida-pagamenti-rendicontazione.module').then(m => m.GuidaPagamentiRendicontazioneModule)
  },
  {
    path: 'auth/callback',
    title: 'Autenticazione in corso',
    loadChildren: () => import('./pages/auth-callback/auth-callback.module').then(m => m.AuthCallbackPageModule)
  },
  {
    path: 'auth/error',
    title: 'Errore di autenticazione',
    loadChildren: () => import('./pages/auth-error/auth-error.module').then(m => m.AuthErrorPageModule)
  },
  {
    path: 'error',
    redirectTo: 'auth/error',
  },
  {
    path: '**',
    redirectTo: PathEnum.PAGES + PathEnum.HOME,
  },
];
